module.exports = __webpack_public_path__ + "static/media/weight-sensor.6e0a29a7.png";